import type { ClientAppVariantChangeSelectedGeoAreasRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedAppEventsApi } from '@/features/api/hooks/shared-app/useSharedAppEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForHomeGeoArea } from '@/features/api/utils/postCaches';

export const useChangeSelectedGeoAreas = () => {
  const queryClient = useQueryClient();
  const api = useSharedAppEventsApi();

  return useApiMutation({
    mutationFn: (
      clientAppVariantChangeSelectedGeoAreasRequest: ClientAppVariantChangeSelectedGeoAreasRequest
    ) =>
      api.onAppVariantChangeSelectedGeoAreasRequest({
        clientAppVariantChangeSelectedGeoAreasRequest
      }),
    onSuccess: () => {
      /*
      Todo: invalidation here causes some unsent requests during registration. As we do not use the onboarding endpoint during the app, this might be fine
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ONBOARDING_STATUS]
      });
      */
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.PERSON] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.SELECTED_GEO_AREAS]
      });
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.FEATURES] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.CONVENIENCES]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATIONS]
      });
      invalidatePostCachesForHomeGeoArea(queryClient);
    }
  });
};
